module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap3"
    }
  }, [_vm._v("ISSUES AND ANSWERS")]), _vm._v(" "), _c('p', {
    staticClass: "poem3",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("Home of the brave, land of the free—")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("I don’t want to be mistreated by no bourgeoisie.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—“Bourgeois Blues,” a song by Huddie Ledbetter")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bc96e7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/7-chap3.vue
// module id = 78
// module chunks = 0